import { Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { BackButton, CustomButton, InputTextFieldGrid } from "components";

const CuentaBancariaForm = ({ title, goBack, defaultValues, submit }) => {
  const { control, handleSubmit } = useForm({ defaultValues });

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <div>
          <BackButton name={title} click={goBack} />
        </div>
      </Grid>

      <Grid container justifyContent="center" alignItems="center" mt={"40px"}>
        <Grid width={"70%"} container spacing={3}>
          <InputTextFieldGrid
            label={"Banco"}
            name={"bank"}
            required={"Debes agregar el banco"}
            control={control}
          />
          <InputTextFieldGrid
            label={"N° Cuenta"}
            name={"accountNumber"}
            required={"Debes agregar el número de cuenta"}
            control={control}
          />
          <InputTextFieldGrid
            label={"N° Cuenta CLABE"}
            name={"clabe"}
            required={"Debes agregar la cuenta CLABE"}
            control={control}
            rules={{
              pattern: {
                value: /^\d{18}$/,
                message: "La CLABE debe contener 18 dígitos",
              },
            }}
          />
          <InputTextFieldGrid
            label={"Beneficiario"}
            name={"beneficiary"}
            required={"Debes agregar el beneficiario"}
            control={control}
          />

          <Grid container justifyContent="center" mt={5}>
            <CustomButton click={handleSubmit(submit)} name={"Guardar"} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CuentaBancariaForm;
